(function () {
  var drawer = document.getElementById('CartDrawer');

  function money(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return amount.toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'USD'
      });
    } catch (err) {
      return '$' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  async function refreshDrawer() {
    if (!drawer) return null;
    var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
    var body = drawer.querySelector('[data-cart-body]');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    var tip = drawer.querySelector('[data-cart-tip]');
    var checkout = drawer.querySelector('[data-cart-checkout]');

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count ? String(cart.item_count) : '';
    });

    if (sub) sub.textContent = money(cart.total_price, cart.currency);
    if (tip) {
  var threshold = 7000;
  var remaining = threshold - cart.total_price;
  if (!cart.item_count) {
    tip.textContent = '';
  } else if (remaining > 0) {
    tip.textContent = 'Add ' + money(remaining, cart.currency) + ' more to save $16 on this order.';
  } else {
    tip.textContent = 'You unlocked $16 off on this order.';
  }
}
    if (checkout) checkout.href = cart.item_count ? '/checkout' : '/cart';

    if (!body) return cart;

    if (!cart.item_count) {
      body.innerHTML = '<p class="muted">Your bag is empty.</p>';
      return cart;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="96" height="96">'
          : '';
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="muted">' + escapeHtml(item.variant_title) + '</p>'
            : '';
        var removeHref =
          '/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0';
        return (
          '<article class="drawer-line">' +
          '<a href="' + escapeHtml(item.url) + '">' + img + '</a>' +
          '<div>' +
          '<a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' +
          variant +
          '<p class="muted">Qty ' + escapeHtml(item.quantity) + '</p>' +
          '<a class="remove" href="' + removeHref + '">Remove from bag</a>' +
          '</div>' +
          '<p>' + money(item.final_line_price, cart.currency) + '</p>' +
          '</article>'
        );
      })
      .join('');

    return cart;
  }

  async function openDrawer() {
    if (!drawer) return;
    await refreshDrawer();
    drawer.hidden = false;
  }

  document.querySelectorAll('.js-open-cart').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  document.querySelectorAll('.js-close-cart').forEach(function (el) {
    el.addEventListener('click', function () {
      if (drawer) drawer.hidden = true;
    });
  });

  document.querySelectorAll('.js-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.getElementById('PdpMain');
      if (main && btn.dataset.src) main.src = btn.dataset.src;
    });
  });

  var form = document.querySelector('.product-form');
  var productCache = null;

  function productHandle() {
    var parts = location.pathname.split('/').filter(Boolean);
    var i = parts.indexOf('products');
    return i >= 0 && parts[i + 1] ? parts[i + 1] : null;
  }

  function selectedOptions(formEl) {
    var options = [];
    var i = 0;
    while (true) {
      var checked = formEl.querySelector('input[name="option-' + i + '"]:checked');
      if (checked) {
        options.push(checked.value);
        i += 1;
        continue;
      }
      var select = formEl.querySelector('select[name="option-' + i + '"]');
      if (select) {
        options.push(select.value);
        i += 1;
        continue;
      }
      break;
    }
    return options;
  }

  function imageUrl(image) {
    if (!image) return null;
    var src = image.src || image;
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src.indexOf('width=') === -1) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=1400';
    }
    return src;
  }

  async function syncVariant() {
    if (!form) return;
    var handle = productHandle();
    if (!handle) return;
    if (!productCache) {
      productCache = await fetch('/products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        return r.json();
      });
    }
    var selected = selectedOptions(form);
    var variant = (productCache.variants || []).find(function (v) {
      return (v.options || []).every(function (opt, idx) {
        return opt === selected[idx];
      });
    });
    if (!variant) return;

    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = String(variant.id);

    var main = document.getElementById('PdpMain');
    var src = imageUrl(variant.featured_image);
    if (main && src) {
      main.src = src;
      if (variant.featured_image && variant.featured_image.alt) {
        main.alt = variant.featured_image.alt;
      }
    }

    var url = new URL(location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState({}, '', url);
  }

  if (form) {
    form.querySelectorAll('input[type="radio"][name^="option-"], select[name^="option-"]').forEach(function (el) {
      el.addEventListener('change', function () {
        syncVariant();
      });
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      await syncVariant();
      var data = new FormData(form);
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      await openDrawer();
    });

    syncVariant();
  }
})();